import api from './api';

export const getNotifications = async (page) => {
  const { data } = await api.get(`/notifications/list?page=${page}`);
  return data?.data ?? data;
};

export const markNotificationAsRead = async (id) => {
  const { data } = await api.put(`/notifications/${id}`, { isRead: true });
  return data?.data ?? data;
};
